



// export interface  CampaignInterfaceData {
//   ad_id: string,
//   ad_name: string,
//   ads_status: string,
//   campaign_id: string,
//   campaign_name: string,
//   adgroup_id: string,
//   adgroup_name: string,
//   clicks: number,
//   cost: number,
//   impressions: number,
//   date: string
// }
//
// export interface  CampaignIdInterfaceData {
//   camaign_id: string,
//   campaigns: {
//     [key: string]: CampaignInterfaceData
//   }
// }



export interface  CampaignIdInterfaceData {
  campaign_id: string,
  clicks: number,
  cost: number,
  impressions: number,
  conversions?: number,
  date: string
}

export interface  AdgroupIdInterfaceData {
  campaign_id: string,
  adgroup_id: string
  clicks: number,
  cost: number,
  impressions: number,
  conversions?: number,
  date: string
}
